/**
 * Image widths getCmsImageAttrs offers in Sanity image srcsets when the image has sizes. The browser picks the smallest
 * width that covers the displayed width times the screen's pixel density, so the steps are close to keep it from
 * downloading much more than it shows. The largest is also the most any srcset asks for.
 * (next/image's list jumped from 768 to 1440, so phones and 2x desktops took 1440 for cards about 400px wide.)
 */
export const SRCSET_WIDTHS: readonly number[] = [160, 240, 320, 480, 640, 768, 960, 1080, 1280, 1440];

/**
 * Sanity quality (q) for the widths only 2x+ screens pick (see getCmsImageAttrs). Sanity's default is 75.
 * On a 2x screen the extra pixels hide the compression, and it cuts the bytes by about a third (AVIF) to a half.
 */
export const HIGH_DENSITY_QUALITY = 55;

/**
 * The widest screen counted as 1x when working out an image's largest slot from vw in sizes.
 * Wider screens (4K) are almost always scaled to 2x.
 */
export const MAX_1X_VIEWPORT = 2560;
